import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getFAICurrentInspection } from './getFAICurrentInspection';

const getFAIApproved = createSelector(
  [getFAICurrentInspection],
  (currentInspection) => {
    return currentInspection?.status === FAI_STATUS.APPROVED;
  }
);

export { getFAIApproved };
